const constants = {
    BASEURL: process.env.REACT_APP_BASEURL || "http://localhost:3500/api/v1"
};

export default constants;